import React, { useState, useContext, useEffect } from "react";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Uploader from "../components/playerphotos/UploaderPlayerPhotos";
import Wrapper from "../components/layout/Wrapper";
import CopyToClipboardButton from "../components/widgets/CopyToClipboardButton";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import FileList from "../components/playerphotos/FileList";

import usePlayerPhotos from "../hooks/usePlayerPhotos";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function PlayerPhotos({ parent }) {
   const [pageSize, setPageSize] = useState(100);
   const [pageSizeLibrary, setPageSizeLibrary] = useState(100);
   
   // USE HOOK
   const [
      playerList,
      fileList,
      replaceFilename,
      setReplaceFilename,
      lastFileUpdate,
      setLastFileUpdate,
      notification,
      {
         getPlayerList,
         getFileList,
         refreshPlayerPhotos,
         clearPlayerSelection,
         updatePlayerPhoto,
         deleteFile,
      },
   ] = usePlayerPhotos();
   
   const getPlayerName = (playerId) => {
      const foundName = _.find(playerList, (row) => row.id == playerId);
      if (foundName) {
         return foundName.PlayerNameLastFirst;
      } else {
         return ""
      }
   }
   
   const allPhotos = _.orderBy(_.map(fileList, (row, i)=> {return {id: i, fileName: row.fileName, playerName: getPlayerName(row.playerId), playerId: row.playerId}}),
      [(photo) => photo.fileName.toLowerCase()],
      ["asc"]
   );
   
   useEffect(() => {
      getPlayerList();
      getFileList();
   }, []);
   
   const columns = [
      {
         field: "id",
         headerName: "Row ID",
         editable: false,
         width: 100,
         filterable: false,
         disableExport: true
      },
      {
         field: "fileName",
         headerName: "FileName",
         editable: false,
         width: 350,
         renderCell: (params) => (
            <>
               {params.row.fileName}
            </>
         )
      },
      {
         field: "playerName",
         headerName: "Assigned Player",
         editable: false,
         width: 250
      },
      {
         field: "url",
         headerName: "Image Path",
         editable: false,
         width: 700,
         filterable: false,
         disableExport: true,
         renderCell: (params) => (
            <>
               <Button href={SERVER_URL + `/uploads/playerphotos/${params.row.fileName}`} target="_new">OPEN</Button>
               {SERVER_URL + `/uploads/playerphotos/${params.row.fileName}`}
            </>
         ),
      },
   ]
   
   return (
      <Wrapper>
         <Stack direction='row' spacing={2} alignItems='center' sx={{ mb: 2 }}>
            <Typography
               variant='h3'
               component='div'
               sx={{ 
                  whiteSpace: "nowrap",
                  textTransform: "uppercase", }}
            >
               All Player Photos
            </Typography>
            
            {parent != "producer" && (
               <Box sx={{ width: "100%" }}>
                  <Uploader callback={refreshPlayerPhotos} />
               </Box>
            )}
            
            <Button onClick={refreshPlayerPhotos} sx={{width: 300}} variant="outlined">REFRESH FILE LIST</Button>
            </Stack>
            
            <Box sx={{ height: 850, width: "100%" }}>
            <DataGrid
               disableColumnSelector
               disableDensitySelector
               density='compact'
               sx={{ backgroundColor: "#efefef" }}
               rowHeight={50}
               columns={columns}
               rows={allPhotos}
               pageSize={pageSize}
               onPageSizeChange={(newPageSize) =>
                  setPageSize(newPageSize)
               }
               rowsPerPageOptions={[20, 100]}
               components={{ Toolbar: GridToolbar }}
               componentsProps={{
                  toolbar: {
                     printOptions: {
                        disableToolbarButton: true,
                     },
                  },
               }}
               
              columnVisibilityModel={{id: false}}
               disableSelectionOnClick
            />
            </Box>
      </Wrapper>
   );
}
